export const initialState = {
  isHistoryOpened: false,
  vinHistory: [],
  loadedPages: [],
  totalItems: 0,
  fetchHistory: false,
  fetchError: false,
};
